import { getApiConfig } from '../config/markets.js';

const API_URL = getApiConfig().apiUrl;
const BASE = `${API_URL}/admin/api-keys`;

async function request(path, options = {}) {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No token');

  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });

  if (!res.ok) {
    let msg = 'API Keys request failed';
    try {
      const data = await res.json();
      msg = data.error || data.message || msg;
    } catch {}
    throw new Error(msg);
  }

  if (res.status === 204) return null;
  return res.json();
}

export const fetchApiKeys = () => request('/').then((r) => r.items || []);
export const fetchPermissions = () => request('/permissions').then((r) => r.permissions || []);
export const createApiKey = (payload) =>
  request('/', { method: 'POST', body: JSON.stringify(payload) });
export const updateApiKey = (id, payload) =>
  request(`/${id}`, { method: 'PATCH', body: JSON.stringify(payload) });
export const revokeApiKey = (id) => request(`/${id}/revoke`, { method: 'POST' });
export const activateApiKey = (id) => request(`/${id}/activate`, { method: 'POST' });
export const deleteApiKey = (id) => request(`/${id}`, { method: 'DELETE' });
